// В.2.a: Лив Лайф — загрузчик с предупреждением о пропущенных способностях.
// Аналог src/engine/abilities/global/warn-unimplemented.js, но для faction='livlife'.
//
// На В.2.a почти все способности Лив Лайф НЕ реализованы — карты грузятся
// с базовыми статами + keyword'ами, а при выставлении (или розыгрыше Действия)
// мы один раз пишем console.warn о каждом непустом ability_text-поле, для
// которого нет регистрации через registerImplementedAbility(cardId, abilityType).
//
// Карты будут регистрироваться в шагах В.2.b … В.2.h по мере реализации.

const _warned = new Set();

const ABILITY_FIELDS = [
  'passive', 'order', 'active', 'trigger',
  'deathrattle', 'aura', 'oneshot', 'summon'
];

// (id, field) — для них warning'и НЕ выводятся.
// Регистрируется через registerImplementedAbility из ability-файлов Лив Лайф.
const _implemented = new Set();

export function registerImplementedAbility(cardId, ...fields) {
  for (const f of fields) _implemented.add(`${cardId}|${f}`);
}

// Юнит/Герой Лив Лайф вышел на поле — предупредить о его способностях.
export function warnUnimplementedLivLifeAbilities(card) {
  if (!card) return;
  if (card.faction !== 'livlife') return;
  const at = card.ability_text;
  if (!at || typeof at !== 'object') return;
  for (const f of ABILITY_FIELDS) {
    const val = at[f];
    if (val == null || val === '') continue;
    const key = `${card.id}|${f}`;
    if (_warned.has(key)) continue;
    if (_implemented.has(key)) continue;
    _warned.add(key);
    console.warn(`[Корпы] карта ${card.id}: способность ${f} не реализована, пропущена`);
  }
}

// Только для тестов: сбросить кэш предупреждений.
export function _resetLivLifeWarnCacheForTests() {
  _warned.clear();
}
